import { render, staticRenderFns } from "./Anmeldung.vue?vue&type=template&id=5f5df872"
import script from "./Anmeldung.vue?vue&type=script&lang=js"
export * from "./Anmeldung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5df872')) {
      api.createRecord('5f5df872', component.options)
    } else {
      api.reload('5f5df872', component.options)
    }
    module.hot.accept("./Anmeldung.vue?vue&type=template&id=5f5df872", function () {
      api.rerender('5f5df872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Anmeldung.vue"
export default component.exports